

export const dashMethods = {
    methods: {
        addPanel(config, gaugeKey) {
       
            var width = 5;
            var height = 15;
      
            var template = { x: 0, y: 0, w: width , h: height, i: gaugeKey };
            if (config.length > 0) {
                // Si existe panel
                var y = 0;
                var x = 0;
                config.forEach((element, index) => {
                    console.log(element);
                    if (element.y > y) {
                        y = element.y
                    }
                });
                config.forEach((element, index) => {
                    console.log(element);
                    if (element.y == y) {
                        if (element.x > x) {
                            x = element.x;
                        }

                    }
                });
                var double = width*2;
                if ((x + template.w) >= double) {
                    y = y + height;
                    x = 0;
                } else {
                    x = x + template.w;
                }


                console.log('x:' + x + ' Y:' + y);


                var panel = { x: x, y: y, w: width, h: height, i: gaugeKey };
                console.log(panel);

                config.push(panel);
                return config;

            } else {
                return config;
                //Si no hay panels
            }


        },
        getDashboard(dashKey) {
            return new Promise((resolve, reject) => {
                var that = this;
                var dat = JSON.stringify({
                    key: dashKey

                });
                axios
                    .post(
                        this.$store.getters.getMainUrl + "getDashboard",
                        dat
                    )
                    .then(function (response) {
                        console.log(response);
                        if (response.data.success == true) {

                            resolve(response.data.data);
                        } else {
                            reject(false);
                        }
                    })
                    .catch(function (error) {
                        console.log("Error");
                        console.log(error);
                        reject(false);
                    });
            });

        },
        async editDashPanels(dashKey, dashConfig) {
            return new Promise((resolve, reject) => {
                var that = this;
                var dat = JSON.stringify({
                    token: this.$store.state.userInfo.token,
                    providerID: this.$store.state.userInfo.net,
                    data: {
                        key: dashKey,
                        dashConfig: dashConfig
                    }
                });
                axios
                    .post(
                        this.$store.getters.getMainUrl + "editDashboard",
                        dat
                    )
                    .then(function (response) {
                        console.log(response);
                        if (response.data.success == true) {

                            resolve(true);
                        } else {
                            reject(false);
                        }
                    })
                    .catch(function (error) {
                        console.log("Error");
                        console.log(error);
                        reject(false);
                    });
            });

        },
        async addGaugePanel(gaugeKey, dashKey) {
            var that = this;

            return new Promise(async (resolve, reject) => {
                const dashData = await that.getDashboard(dashKey);
                const panels = await that.addPanel(dashData.dashConfig, gaugeKey);
                const editDashConfig = await that.editDashPanels(dashKey, panels);
                console.log('EditDashConfig');
                console.log(editDashConfig);


                resolve(true);

            });



        }, searchName(name) {
            return new Promise((resolve, reject) => {
                var that = this;
                var dat = JSON.stringify({
                    token: this.$store.state.userInfo.token,
                    nombre: name

                });
                axios
                    .post(
                        this.$store.getters.getMainUrl + "checkProjectName",
                        dat
                    )
                    .then(function (response) {
                        console.log(response.data);


                        resolve(response.data);

                    })
                    .catch(function (error) {
                        console.log("Error");
                        console.log(error);
                        reject(false);
                    });
            });
        }


    }
};